import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import { device } from '../breakpoints'

const ExampleComponent: FC = (): ReactElement => {
  return (
    <Container>
      <IllustrationContainer>
        <Content>
          <TextContainer>
            <Title>
              Avec Signé Genève partez à la découverte de ce qui se passe près
              de chez vous
            </Title>
            <Text>
              Des informations de proximité rédigées par des reporters de
              quartiers. <Link target='_blank' href='https://www.tdg.ch/signe-geneve-qui-sommes-nous-106331539260'>En savoir plus</Link>.
            </Text>
            <Link target='_blank' href='https://www.facebook.com/groups/signegeneve'><Button>Participer sur Facebook</Button></Link>
          </TextContainer>
          <Logo src={require('../logo_wide.svg').default} />
        </Content>
      </IllustrationContainer>
    </Container>
  )
}

const Container = styled.div`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  -webkit-font-smoothing: antialiased;
`

const Link = styled.a`
  cursor: pointer;
  color: var(--text-color);
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
`

const TextContainer = styled.div``

const IllustrationContainer = styled.div`
  width: 100%;
  background-image: url(${require('../illustration_desktop.jpg')});
  background-size: 700px;
  background-repeat: no-repeat;
  font-family: var(--font-sans-serif);
  background-color: #96d0cf;

  background-size: 90%;
  background-position: center calc(100% + 6px);

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    background-size: 90%;
    background-position: center calc(100% + 5px);
  }

  @media ${device.tablet}, @media ${device.laptop} {
    background-size: 570px;
    background-position: 94% calc(100% + 9px);
  }
`

const Content = styled.div`
  display: grid;
  padding: 20px;
  padding-bottom: 70px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    grid-template-columns: 1fr;
    grid-template-rows: min-content 1fr;
    padding-bottom: 70px;
    padding-left: 20px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    grid-template-columns: 1fr min-content;
    grid-template-rows: 1fr;
    padding-bottom: 20px;
    padding-left: 40px;
  }
`

const Title = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 0.65rem;
`

const Text = styled.div`
  font-size: 1.5rem;
  line-height: 2.2rem;
  margin-bottom: 1.5rem;
`

const Logo = styled.img`
  width: 150px;
  margin-bottom: 1.5rem;

  order: -1;
  justify-self: right;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    order: -1;
    justify-self: right;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    order: 1;
    justify-self: left;
  }
`

const Button = styled.button`
  background-color: var(--text-color);
  color: white;
  padding: 10px 20px;
  border: none;
  outline: none;
  font-family: var(--font-sans-serif);
  font-weight: 700;
  cursor: pointer;
`

export default ExampleComponent
